import React, { useState, useEffect } from 'react';

function Sip1() {
  const [images, setImages] = useState([
    {
      id: 2,
      src: "/images/1.png",
      alt: "Mentorship",
      title: "Expert Guidance",
      description: "Learn from industry experts"
    }
  ]);

  const [documents, setDocuments] = useState([
    {
      id: 1,
      name: "SIP 2026 Instructions",
      filePath: "/documents/SIP_2026Instructions.pdf",
      icon: "📄",
      type: "PDF",
      size: "2.4 MB",
      description: "Program guidelines and eligibility criteria"
    },
    {
      id: 2,
      name: "SIP Projects List for Round 3",
      filePath: "/documents/SIP_Project_Details_Round_3.xlsx",
      icon: "📊",
      type: "XLSX",
      size: "1.8 MB",
      description: "Available projects and prerequisites"
    },
  ]);

  const [loading, setLoading] = useState({});
  const [hoveredDoc, setHoveredDoc] = useState(null);
  const [downloadError, setDownloadError] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const deadlineDate = new Date(2026, 3, 16, 14, 0, 0); // April 16, 2026, 14:00:00

    const timer = setInterval(() => {
      const now = new Date();
      const difference = deadlineDate - now;

      if (difference <= 0) {
        setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(timer);
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        setTimeRemaining({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleDownload = (doc, e) => {
    e.preventDefault();
    setLoading(prev => ({ ...prev, [doc.id]: true }));
    setDownloadError(null);

    const link = document.createElement('a');
    link.href = doc.filePath;
    link.download = doc.name + (doc.type === 'PDF' ? '.pdf' : '.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      setLoading(prev => ({ ...prev, [doc.id]: false }));
    }, 1000);
  };

  return (
    <div style={styles.container}>
      {/* Animated Background */}
      <div style={styles.background}>
        <div style={styles.blob1}></div>
        <div style={styles.blob2}></div>
      </div>

      <div style={styles.contentWrapper}>
        {/* Hero Section */}
        <div style={styles.heroSection}>
          <div style={styles.heroContent}>
            <h1 style={styles.mainHeading}>
              Summer Internship
              <span style={styles.highlight}> Portal</span>
            </h1>
          </div>
          
          <div style={styles.heroVisual}>
            <div 
              style={{...styles.statusCard, cursor: 'pointer'}} 
              // onClick={() => window.location.href = '/login'}
              // role="button"
              // tabIndex={0}
              // onKeyPress={(e) => {
              //   if (e.key === 'Enter' || e.key === ' ') {
              //     window.location.href = '/verify_email';
              //   }
              // }}
            ><div>

              <div style={styles.statusBody}>
                <span style={{...styles.statusText, color: '#ef3c0a', fontWeight: 'bold', fontSize: '1.2rem'}}>
                  Registrations are closed for Round 3
                </span>
                {/* <p style={{color: '#ef3c0a', fontSize: '1rem', marginTop: '8px'}}>Click Here to Login</p> */}
              </div>

            </div>
            </div>
          </div>
        </div>

        {/* Deadline Banner */}
        {/* <div style={styles.deadlineBanner}>
          {/* <div style={styles.deadlineIcon}>⏰</div> */}
          <div style={styles.deadlineContent}>
            <div style={styles.deadlineTitle}>Round 3: Deadline</div>
            <div style={styles.deadlineText}>
              Submit your preferences by: <strong>04 May 2026, 02:00 PM</strong>
            </div>
          </div>
          {/* <div style={styles.deadlineCountdown}>
            {/* <span style={styles.countdownLabel}>Time Remaining</span>
            <span style={styles.countdownTimer}>
              {timeRemaining.days}d {timeRemaining.hours}h {timeRemaining.minutes}m {timeRemaining.seconds}s
            </span> */}
          {/* </div> */} 
        {/* </div> */} 

        {/* Single Image Section */}
        <div style={styles.imageSection}>
          <div style={styles.sectionHeader}>
            {/* <h2 style={styles.sectionTitle}>Program Highlight</h2>
            <p style={styles.sectionSubtitle}>Experience what makes our internship unique</p> */}
          </div>

          <div style={styles.singleImageContainer}>
            {images.map((image) => (
              <div key={image.id} style={styles.imageCard}>
                <div style={styles.imageWrapper}>
                  <img 
                    src={image.src}
                    alt={image.alt}
                    style={styles.image}
                    loading="lazy"
                  />
                  <div style={styles.imageOverlay}>
                    <h3 style={styles.imageTitle}>{image.title}</h3>
                    <p style={styles.imageDescription}>{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Information Text Section */}
        <div style={styles.infoSection}>
          <div style={styles.infoCard}>
            <h2 style={styles.infoHeading}>Summer Internship Programme 2026 at NIT Calicut</h2>
            <p style={styles.infoText}>
              Online applications are invited from eligible students to pursue the Summer Internship Programme 2026 at NIT Calicut. The internship will be offered for a duration of 60 days or 30 days in offline, online, or hybrid modes.
            </p>
            <p style={styles.infoText}>
              Students opting for the two-month internship should report between May 4 and May 15, 2026, and the internship must be completed by July 15, 2026. Students opting for the one-month internship must report on or before June 15, 2026.
            </p>
            <p style={styles.infoText}>
              The registration will commence on March 12, 2026 and close on March 23, 2026. The selection process will have three rounds of allotment, and applicants who are not allotted in one round will be considered in the subsequent rounds. Allotment will be based on the applicant's credentials and preferences.
            </p>
            <p style={styles.infoText}>
              Selected students will undertake the internship using the Institute's facilities under the mentorship of an assigned faculty member.
            </p>
            <p style={styles.infoText}>
              You may register after carefully reading the instructions given below.
            </p>
            <p>
              For any queries , please send a mail to sip@nitc.ac.in.
            </p>
          </div>
        </div>

        {/* Documents Section */}
        <div style={styles.documentsSection}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Instructions</h2>
            <p style={styles.sectionSubtitle}>Download important documents for your internship</p>
          </div>

          <div style={styles.documentGrid}>
            {documents.map((doc) => (
              <div 
                key={doc.id}
                style={{
                  ...styles.documentCard,
                  ...(hoveredDoc === doc.id ? styles.documentCardHover : {})
                }}
                onMouseEnter={() => setHoveredDoc(doc.id)}
                onMouseLeave={() => setHoveredDoc(null)}
              >
                <div style={styles.documentIconWrapper}>
                  <span style={styles.documentIcon}>{doc.icon}</span>
                </div>
                
                <div style={styles.documentContent}>
                  <h3 style={styles.documentName}>{doc.name}</h3>
                  <p style={styles.documentDescription}>{doc.description}</p>
                  <div style={styles.documentMeta}>
                    <span style={styles.documentType}>{doc.type}</span>
                    <span style={styles.documentSize}>{doc.size}</span>
                  </div>
                </div>

                <button
                  onClick={(e) => handleDownload(doc, e)}
                  style={{
                    ...styles.downloadButton,
                    ...(loading[doc.id] ? styles.downloadButtonLoading : {}),
                    ...(hoveredDoc === doc.id ? styles.downloadButtonHover : {})
                  }}
                  disabled={loading[doc.id]}
                >
                  {loading[doc.id] ? (
                    <span style={styles.loadingSpinner}>⏳</span>
                  ) : (
                    <span style={styles.downloadIcon}>⬇️</span>
                  )}
                  <span style={styles.downloadText}>
                    {loading[doc.id] ? 'Downloading...' : 'Download'}
                  </span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }

        @keyframes pulse {
          0%, 100% { 
            transform: scale(1); 
            opacity: 1; 
            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
          }
          50% { 
            transform: scale(1.05); 
            opacity: 0.9; 
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shine {
          0% {
            background-position: -100px;
          }
          40%, 100% {
            background-position: 300px;
          }
        }

        @keyframes bounce {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(5px); }
        }

        .image-card {
          animation: slideIn 0.6s ease-out forwards;
          opacity: 0;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .image-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 30px 60px rgba(102, 126, 234, 0.3);
          z-index: 10;
        }

        .image-card:hover .image-wrapper img {
          transform: scale(1.15);
        }

        .image-card:hover .image-overlay {
          opacity: 1;
          transform: translateY(0);
        }

        .image-overlay {
          pointer-events: none;
        }

        @media screen and (max-width: 768px) {
          .hero-section {
            flex-direction: column;
            text-align: center;
          }
          
          .document-grid {
            grid-template-columns: 1fr !important;
          }
          
          .single-image-container {
            padding: 0 15px;
          }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#f8fafc",
    fontFamily: "'Inter', 'Poppins', sans-serif",
    position: "relative",
    overflowX: "hidden",
    padding: "20px"
  },
  background: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
    overflow: "hidden"
  },
  blob1: {
    position: "absolute",
    top: "-100px",
    right: "-100px",
    width: "500px",
    height: "500px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "50%",
    opacity: 0.1,
    filter: "blur(60px)",
    animation: "float 20s infinite"
  },
  blob2: {
    position: "absolute",
    bottom: "-100px",
    left: "-100px",
    width: "500px",
    height: "500px",
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    borderRadius: "50%",
    opacity: 0.1,
    filter: "blur(60px)",
    animation: "float 25s infinite reverse"
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1
  },
  heroSection: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    marginTop: "100px",
    gap: "40px",
    alignItems: "center",
    marginBottom: "60px",
    padding: "40px 0"
  },
  heroContent: {
    animation: "slideIn 0.8s ease-out"
  },
  mainHeading: {
    fontSize: "clamp(2.5rem, 5vw, 4rem)",
    fontWeight: "800",
    color: "#1a1a1a",
    marginBottom: "20px",
    lineHeight: 1.2
  },
  highlight: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block"
  },
  heroVisual: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  statusCard: {
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "320px",
    position: "relative",
    transition: "all 0.3s ease",
    border: "2px solid transparent",
    ':hover': {
      transform: "translateY(-5px)",
      boxShadow: "0 30px 60px rgba(102, 126, 234, 0.3)",
      borderColor: "#667eea"
    }
  },
  loginBadge: {
    position: "absolute",
    top: "-15px",
    right: "20px",
    background: "linear-gradient(135deg, #ff6b6b, #feca57)",
    padding: "8px 20px",
    borderRadius: "50px",
    boxShadow: "0 10px 20px rgba(255, 107, 107, 0.3)",
    animation: "pulse 2s infinite",
    zIndex: 2
  },
  loginBadgeText: {
    color: "white",
    fontWeight: "700",
    fontSize: "0.9rem",
    letterSpacing: "1px"
  },
  loginPromptContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "25px",
    padding: "1px",
    background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
    borderRadius: "50px",
    border: "2px solid #667eea30",
    animation: "pulse 2s infinite"
  },
  loginArrow: {
    fontSize: "1.2rem",
    color: "#667eea",
    fontWeight: "bold",
    animation: "bounce 1s infinite"
  },
  loginText: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#667eea",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  statusHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px"
  },
  pulseDot: {
    width: "10px",
    height: "10px",
    backgroundColor: "#28a745",
    borderRadius: "50%",
    animation: "pulse 2s infinite"
  },
  statusText: {
    fontSize: "0.875rem",
    color: "#666",
    fontWeight: "500"
  },
  statusBody: {
    textAlign: "center"
  },
  openBadge: {
    display: "inline-block",
    padding: "10px 28px",
    background: "linear-gradient(135deg, #05f511 0%, #11f30e 100%)",
    color: "white",
    borderRadius: "50px",
    fontSize: "1rem",
    fontWeight: "700",
    marginBottom: "12px",
    boxShadow: "0 4px 15px rgba(40, 167, 69, 0.3)",
    letterSpacing: "1px"
  },
  registrationDates: {
    fontSize: "0.9rem",
    color: "#666",
    marginTop: "8px",
    fontWeight: "500"
  },
  loginHint: {
    marginTop: "20px",
    padding: "10px",
    borderTop: "2px dashed #667eea40",
    background: "#f8f9ff",
    borderRadius: "12px"
  },
  loginHintText: {
    color: "#667eea",
    fontSize: "0.9rem",
    fontWeight: "600",
    display: "block"
  },
  deadlineBanner: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "16px",
    padding: "20px 30px",
    margin: "20px 0 40px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "20px",
    boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
    position: "relative",
    overflow: "hidden"
  },
  deadlineIcon: {
    fontSize: "2rem",
    animation: "pulse 2s infinite"
  },
  deadlineContent: {
    flex: 1
  },
  deadlineTitle: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "rgba(255,255,255,0.9)",
    marginBottom: "4px"
  },
  deadlineText: {
    fontSize: "1rem",
    color: "white",
    fontWeight: "500"
  },
  deadlineCountdown: {
    textAlign: "right",
    backgroundColor: "rgba(255,255,255,0.2)",
    padding: "10px 20px",
    borderRadius: "12px",
    backdropFilter: "blur(10px)"
  },
  countdownLabel: {
    fontSize: "0.75rem",
    color: "rgba(255,255,255,0.8)",
    display: "block",
    marginBottom: "4px"
  },
  countdownTimer: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: "white",
    letterSpacing: "1px"
  },
  imageSection: {
    marginBottom: "60px"
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: "40px"
  },
  sectionTitle: {
    fontSize: "clamp(1.5rem, 3vw, 2rem)",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "10px"
  },
  sectionSubtitle: {
    fontSize: "1rem",
    color: "#666"
  },
  singleImageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageCard: {
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "white",
    height: "500px",
    width: "800px",
    maxWidth: "90%",
    position: "relative"
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafc"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    padding: "20px"
  },
  imageOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "20px",
    background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
    color: "white",
    opacity: 0,
    transform: "translateY(20px)",
    transition: "all 0.3s ease"
  },
  imageTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    marginBottom: "5px"
  },
  imageDescription: {
    fontSize: "1rem",
    opacity: 0.9
  },
  infoSection: {
    marginBottom: "60px",
    padding: "0 20px"
  },
  infoCard: {
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    maxWidth: "900px",
    margin: "0 auto"
  },
  infoHeading: {
    fontSize: "clamp(1.5rem, 3vw, 2rem)",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "25px",
    textAlign: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
  },
  infoText: {
    fontSize: "1rem",
    color: "#444",
    lineHeight: 1.8,
    marginBottom: "20px",
    textAlign: "justify"
  },
  documentsSection: {
    marginBottom: "40px"
  },
  filePathSmall: {
    fontSize: "0.7rem",
    color: "#999",
    marginTop: "5px",
    fontFamily: "monospace"
  },
  documentGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "20px",
    marginBottom: "30px"
  },
  documentCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "15px",
    padding: "20px",
    backgroundColor: "white",
    borderRadius: "16px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
    transition: "all 0.3s ease",
    border: "2px solid transparent"
  },
  documentCardHover: {
    transform: "translateY(-5px)",
    boxShadow: "0 20px 30px rgba(102, 126, 234, 0.2)",
    borderColor: "#667eea"
  },
  documentIconWrapper: {
    width: "50px",
    height: "50px",
    backgroundColor: "rgba(102, 126, 234, 0.1)",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem"
  },
  documentIcon: {
    fontSize: "1.5rem"
  },
  documentContent: {
    flex: 1
  },
  documentName: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#1a1a1a",
    marginBottom: "4px"
  },
  documentDescription: {
    fontSize: "0.875rem",
    color: "#666",
    marginBottom: "8px"
  },
  documentMeta: {
    display: "flex",
    gap: "10px"
  },
  documentType: {
    fontSize: "0.75rem",
    color: "#667eea",
    backgroundColor: "rgba(102, 126, 234, 0.1)",
    padding: "2px 8px",
    borderRadius: "50px"
  },
  documentSize: {
    fontSize: "0.75rem",
    color: "#999"
  },
  downloadButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    backgroundColor: "#667eea",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "0.875rem",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap"
  },
  downloadButtonHover: {
    backgroundColor: "#764ba2",
    transform: "scale(1.05)"
  },
  downloadButtonLoading: {
    opacity: 0.7,
    cursor: "not-allowed"
  },
  downloadIcon: {
    fontSize: "1rem"
  },
  downloadText: {
    fontSize: "0.875rem"
  },
  loadingSpinner: {
    animation: "pulse 1s infinite"
  }
};

export default Sip1;